import { AxiosRequestConfig } from 'axios';
import { getApiv14 } from './apiv14Setup';

export const asyncJobProgress = (id: string, config?: AxiosRequestConfig) => {
  return getApiv14().get('/async_op_result/' + id, config);
};
